<fgbcl-game-banner></fgbcl-game-banner>
<div class="container">
  <p>
    Ticket successfully transferred to
    <span class="email">{{ (transferedTickets$ | async)[0].RecipientEmailAddress }}</span>
  </p>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Ticket Number</th>
        <th scope="col">Area</th>
        <th scope="col">Section</th>
        <th scope="col">Row</th>
        <th scope="col">Seat</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of transferedTickets$ | async">
        <th scope="row">{{ item.ACN }}</th>
        <td>
          {{ item.Area }}
        </td>
        <td>{{ item.Stand }}</td>
        <td>{{ item.Row }}</td>
        <td>{{ item.Seat }}</td>
      </tr>
    </tbody>
  </table>

  <div class="form-group">
    <button class="btn btn-primary" type="button" routerLink="/ticketTransfer/tickets/{{ selectedGame.GameNumber }}">
      <span class="icon material-icons float-left">arrow_back_ios</span>
      Back To Tickets
    </button>
  </div>
</div>

<div class="container card">
  <div class="row">
    <div class="col-6 d-inline-flex align-items-center">
      <div class="icon-backward-7 success-page-icon"></div>
      <div class="pl-4">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
        aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
      </div>
    </div>
    <div class="col-6 d-inline-flex align-items-center">
      <div class="icon-timer-1 success-page-icon"></div>
      <div class="pl-4">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
        aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
      </div>
    </div>
  </div>
</div>
